import { useMemo } from 'react'
import { DWELLING_YEAR_THRESHOLD } from '../ConstructionTimelineTab.constants'

interface ConstructionDatesResult {
  constructionDates: number[]
  dwellingYears: number[]
}

export const useConstructionDates = (
  building: any
): ConstructionDatesResult => {
  return useMemo(() => {
    // Get construction dates from buildings_administrative if available
    const constructionDates = (
      building.buildings_administrative
        ?.map((admin: any) => admin.building_construction_date)
        .filter(Boolean) || []
    ).filter(
      (date: any, index: any, self: any) => date && self.indexOf(date) === index
    ) // Remove duplicates

    // Get dwelling building years separately (only if > DWELLING_YEAR_THRESHOLD)
    const dwellingYears = (
      building.buildings_administrative?.flatMap(
        (admin: any) =>
          admin.addresses?.flatMap(
            (address: any) =>
              address.dwellings
                ?.map((dwelling: any) => dwelling.building_year)
                .filter(
                  (year: number) => year && year > DWELLING_YEAR_THRESHOLD
                ) || []
          ) || []
      ) || []
    ).filter(
      (date: any, index: any, self: any) => date && self.indexOf(date) === index
    ) // Remove duplicates

    return { constructionDates, dwellingYears }
  }, [building.buildings_administrative])
}
